/**
 * Gets a nested value from an object using a string path.
 * @param {any} obj - The object to search in.
 * @param {string} path - The path to the desired value, e.g., "a.b.c".
 * @returns {any} The value at the specified path, or undefined if not found.
 */
export const getNestedValue = (obj: any, path: string): any => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};
